export interface ConditionOption {
  id: string;
  label: string;
  icon: string;
  description: string;
}

export const CCS_CONDITIONS: ConditionOption[] = [
  {
    id: "conjunctivitis_infective",
    label: "Acute Infective Conjunctivitis",
    icon: "👁️",
    description: "Red, irritated, or discharging eyes",
  },
  {
    id: "rhinitis_allergic",
    label: "Allergic Rhinitis & Conjunctivitis",
    icon: "🌿",
    description: "Hay fever, sneezing, runny nose, itchy eyes",
  },
  {
    id: "impetigo",
    label: "Impetigo",
    icon: "🔴",
    description: "Skin infection with sores or blisters",
  },
  {
    id: "oral_thrush",
    label: "Oral Thrush",
    icon: "😮",
    description: "White patches in mouth, soreness",
  },
  {
    id: "shingles",
    label: "Shingles",
    icon: "⚡",
    description: "Painful rash, often on one side of the body",
  },
  {
    id: "vv_thrush",
    label: "Vulvovaginal Thrush",
    icon: "🛡️",
    description: "Vaginal itching, discharge, or irritation",
  },
  {
    id: "cold_sores",
    label: "Cold Sores (Herpes Labialis)",
    icon: "🌡️",
    description: "Blisters around the lips or mouth",
  },
  {
    id: "uti",
    label: "Uncomplicated Lower UTI",
    icon: "💧",
    description: "Burning sensation when urinating, frequency",
  },
];
